<!-- Error notification -->
<app-collapsible [trigger]="!!log.newError">
  <div class="error-handler notification-banner">
    @if (log.newError) {
      <div class="row">
        <div class="col-md-10">
          <h3>Error</h3>
          {{ log.newError.text }}
          @if (log.newError.exception) {
            <p> {{ log.newError.exception.exceptionMessage }} </p>
          }
        </div>
        <div class="col-md-2 buttons">
          <button class="btn btn-lg btn-default" (click)="log.clearNew()">Close</button>
        </div>
      </div>
    }
  </div>
</app-collapsible>

<!-- Offline notification -->
<app-collapsible [trigger]="log.notifyIsOffline">
  <div class="error-handler offline notification-banner">
    <div class="row">
      <div class="col-grow">
        <h3 style="margin-top:0">You appear to be offline</h3>
        <p>Please check your internet connection</p>
        <div style="margin-top:15px;">
          <button style="font-size:20px;padding:10px; min-width: 200px" class="btn btn-lg btn-primary" (click)="log.notifyIsOffline = false">OK</button>
          <button style="font-size:20px;padding:10px; min-width: 200px" class="btn btn-lg btn-default" (click)="reload()">Reload</button>
        </div>
      </div>
    </div>
  </div>
</app-collapsible>

<!-- New version notification -->
<app-collapsible [trigger]="updater.updateRequired">
  <div class="updater notification-banner">
    <div class="row">
      <div class="col-md-6">
        @if (!updater.updating) {
          <span>A new version is available</span>
        }
        @if (updater.updating) {
          <span>Updating - please wait...</span>
        }
      </div>
      <div class="col-md-6 buttons">
        @if (!updater.updating) {
          <div>
            <button class="btn btn-lg btn-primary" (click)="updater.update()">Update now</button>
            <button class="btn btn-lg btn-default" (click)="updater.postpone()">Update later</button>
          </div>
        }
        @if (updater.updating) {
          <div>
            <app-spinner [light]="true"></app-spinner>
          </div>
        }
      </div>
    </div>
  </div>
</app-collapsible>

<app-collapsible [trigger]="!layout.state.fullscreen">
  <app-branding [appVersion]="updater.version.current"></app-branding>

  <app-nav>
    <i (click)="layout.toggleNavbar()" class="fa fa-bars "></i>
  </app-nav>
  @if (layout.state.xs) {
    <app-nav [direction]="'vertical'" [isOpen]="layout.state.navbarOpen"></app-nav>
  }

</app-collapsible>


<!-- Main page content -->
<div role="main" class="page fadein" [class.fullscreen]="layout.state.fullscreen" [class.account-mode]="layout.state.accountMode">
  <router-outlet></router-outlet>

  <!-- Displays when page is not authorised -->
  @if (log.newRouteBlock) {
    <div class="fadein">
      <div class="route-block">
        <i class="fa fa-ban" aria-hidden="true"></i>
        <h1>Unauthorised</h1>
        <p class="intro-text">
          {{ log.newRouteBlock.text }}
        </p>
      </div>
    </div>
  }
</div>

<app-tooltip-container></app-tooltip-container>

@if (layout.state.overlay || log.notifyIsOffline) {
  <div class="overlay fadein"></div>
}